import type { UserSession } from '@/types/auth';
import { devPersonaToSession, getActiveDevPersona } from '@/lib/dev-auth-personas';

/** Check if dev auth bypass is enabled (dev mode only). Skips the login screen only — does not enable API mocks. */
export function isDevAuth(): boolean {
  return import.meta.env.DEV && import.meta.env.VITE_DEV_AUTH === 'true';
}

/**
 * Check if the legacy dev-mock interceptor is active. Opt-in only (`VITE_DEV_MOCKS=true`).
 * Default is off: local dev hits the V3 TS backend on `:4000` with real Supabase data.
 */
export function isDevMocks(): boolean {
  return import.meta.env.DEV && import.meta.env.VITE_DEV_MOCKS === 'true';
}

/** Default dev session — SSI persona (legacy `dev-token` alias). */
export const DEV_USER: UserSession = devPersonaToSession(getActiveDevPersona());

/** Session for the active dev persona (respects localStorage slug when personas are enabled). */
export function getDevUserSession(): UserSession {
  return devPersonaToSession(getActiveDevPersona());
}

/** Bearer token for the active dev persona. */
export function getDevAccessToken(): string {
  return getActiveDevPersona().token;
}
